module.exports = __webpack_public_path__ + "static/img/banner_01.1bd4053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/lgis/banner_01.jpg
// module id = a/YK
// module chunks = 23